import { ActionManager, Engine, Scene, SceneOptions } from '@babylonjs/core';
import { AdvancedDynamicTexture, Control, Style } from '@babylonjs/gui';

export class GuiOverlay extends Scene {
    public constructor(engine: Engine, options?: SceneOptions) {
        super(engine, options);

        this.autoClear = false;
        this.actionManager = new ActionManager(this);

        this._uiTexture = AdvancedDynamicTexture.CreateFullscreenUI(
            'UI',
            true,
            this
        );
    }

    public get uiTexture(): AdvancedDynamicTexture {
        return this._uiTexture;
    }

    public addControl(control: Control): AdvancedDynamicTexture {
        return this._uiTexture.addControl(control);
    }

    public createStyle(): Style {
        return this._uiTexture.createStyle();
    }

    private readonly _uiTexture: AdvancedDynamicTexture;
}